import { useUser } from "@/store/user";
import type { RouteRecordRedirectOption } from "vue-router";

export const home = (): RouteRecordRedirectOption => {
  const userStore = useUser();

  if (userStore.getSavedRoleName == "hubhead") {
    return { name: "capohub-dashboard" };
  } else if (["thermotechnician", "designer", "asseverator", "security"].indexOf(userStore.getSavedRoleName) >= 0) {
    return { name: "designer-dashboard" };
  } else if (userStore.getSavedRoleName == "specialist") {
    return { name: "specialist-dashboard" };
  } else if (userStore.getSavedRoleName == "backofficeadmin") {
    return { name: "placeholder" };
  } else if (userStore.getSavedRoleName == "backofficeuser") {
    return { name: "backoffice-dashboard" };
  }

  if (!userStore.isLoggedIn) {
    return {
      name: "welcome",
      query: { mode: "FinalUser" },
    };
  }

  if (userStore.isWaiting) {
    return {
      name: "waiting-placeholer",
      query: { mode: "FinalUser" },
    };
  }

  return {
    name: "placeholder",
    query: { mode: "FinalUser" },
  };

  // return {
  //   name: "wrong-role",
  //   query: { mode: "FinalUser" },
  // };
};
